import { useTenantQuery } from '../../../lib/useTenant';

/** Le sezioni del fascicolo di settore che servono al titolare (ADR 0133): numeri del settore e cosa cambierà. */
const PARTS = ['settore', 'previsioni', 'anticipazioni'] as const;

interface Dossier {
  titolo: string;
  sezioni: Array<{ chiave: string; titolo: string; fonte: string; nota?: string; voci: Array<{ testo: string; sintesi?: string[] }> }>;
}

/**
 * Il rapporto sul settore di un'attività (ADR 0133): i numeri ISTAT del settore in Italia, le previsioni di occupazione
 * 2024-2030 e le professioni il cui lavoro sta cambiando, dal fascicolo di settore, ogni parte con la sua fonte. Niente
 * se il fascicolo non le ha.
 */
export function SectorReport({ ateco }: { ateco: string | null }) {
  const code = /^\d{2}(?:\.\d{1,2}){0,2}/.exec(ateco ?? '')?.[0] ?? null;
  const q = useTenantQuery<Dossier>(['standards', 'fascicolo', code], `/standards/fascicolo/${encodeURIComponent(code ?? '')}`, { enabled: !!code });
  const parts = (q.data?.sezioni ?? []).filter((s) => (PARTS as readonly string[]).includes(s.chiave) && s.voci.length);
  if (!parts.length) return null;
  return (
    <details className="group border-t border-black/5 pt-2">
      <summary className="flex cursor-pointer list-none items-center gap-2 text-sm [&::-webkit-details-marker]:hidden">
        <span className="text-xs text-ink/40 transition-transform group-open:rotate-90">▶</span>
        <span className="font-medium text-ink/75">Il tuo settore in numeri e cosa cambierà</span>
      </summary>
      <div className="mt-2 space-y-3 pl-5">
        {parts.map((s) => (
          <section key={s.chiave}>
            <h4 className="text-xs font-semibold text-ink/70">{s.titolo}</h4>
            <ul className="mt-1 space-y-1 text-xs text-ink/70">
              {s.voci.slice(0, 6).map((v) => (
                <li key={v.testo}>
                  {v.testo}
                  {v.sintesi?.slice(0, 2).map((x) => (
                    <span key={x} className="block text-ink/50">
                      {x}
                    </span>
                  ))}
                </li>
              ))}
            </ul>
            <p className="mt-1 text-[11px] text-ink/40">{s.fonte}</p>
          </section>
        ))}
      </div>
    </details>
  );
}
